export const MiniQ2ServerValuesModel = {
    preference_sim: "Preferida SIM0",
    sim0_band: "Automático",
    sim0_pin: "-1",
    sim0_apn_name: "-1",
    sim0_apn_user: "-1",
    sim0_apn_pass: "-1",
    sim1_band: "Automático",
    sim1_pin: "-1",
    sim1_apn_name: "-1",
    sim1_apn_user: "-1",
    sim1_apn_pass: "-1",
}
export const MiniQ2ServerHasModel = {
    preference_sim: true,
    sim0_band: false,
    has_sim0_pin: false,
    has_sim0_apn_name: false,
    has_sim0_apn_user: false,
    has_sim0_apn_pass: false,
    sim1_band: true,
    has_sim1_pin: false,
    has_sim1_apn_name: false,
    has_sim1_apn_user: false,
    has_sim1_apn_pass: false,
}